/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_LineInputs */

const en_field_line = /** @type {(inputs: Field_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Line`)
};

/**
* | output |
* | --- |
* | "Line" |
*
* @param {Field_LineInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const field_line = /** @type {((inputs?: Field_LineInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_LineInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_field_line(inputs)
});